import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable, throwError } from 'rxjs';

import { handleError } from 'src/app/sdc/utils/error.handler';
import {
  api_url,
  TOKEN_EXPIRY,
  TOKEN_EXPIRY_REENTER_MESSAGE,
} from '../utils/constants.helper';
import { MemberUpdateDetailsModel } from '../models/memberupdatedetails.model';
import { LoginService } from './login.service';
import { environment } from '../../../environments/environment';
import { MemberDetailsModel, MemberTypeFormDataModel } from '../models/memberdetails.model';
import { CardActivationModel } from '../models/cardActivationModel';

@Injectable({
  providedIn: 'root',
})
export class MemberService {
  apigee_url: string;

  private memberInputsSubject: BehaviorSubject<MemberTypeFormDataModel | null> = new BehaviorSubject<MemberTypeFormDataModel | null>(null);

  memberInputs: Observable<MemberTypeFormDataModel | null> = this.memberInputsSubject.asObservable();

  private activatedMemberSubject: BehaviorSubject<CardActivationModel | null> = new BehaviorSubject<CardActivationModel | null>(null);

  activatedMember: Observable<CardActivationModel | null> = this.activatedMemberSubject.asObservable();

  constructor(
    private httpClient: HttpClient,
    private loginService: LoginService
  ) {
    this.apigee_url = environment.apigee_sdc_base_url;
  }

  saveMemberInputs(inputs: MemberTypeFormDataModel | null): void {
    this.memberInputsSubject.next(inputs);
  }

  fetchMemberDetails(employeeNo: string, cardNo: string): Observable<MemberDetailsModel> {
    const url = `${this.apigee_url}${api_url.EMPLOYEE_DETAILS}${employeeNo}/cards/${cardNo}`;

    return this.httpClient.get<{data: MemberTypeFormDataModel}>(url).pipe(
      map((response) => response.data),
      catchError((e) => {
        const error = handleError(e).message;
        if (error === TOKEN_EXPIRY) {
          this.loginService.updateRedirectionCheck(TOKEN_EXPIRY_REENTER_MESSAGE);
        }
        return throwError(() => error);
      })
    );
  }

  submitMemberActivation(memberModal: MemberUpdateDetailsModel): Observable<CardActivationModel> {
    return this.httpClient
      .post<{ data: CardActivationModel }>(`${this.apigee_url}${api_url.ACTIVATION}`, memberModal)
      .pipe(
        map((response) => {
          this.activatedMemberSubject.next(response.data);
          return response.data;
        }),
        catchError((e) => {
          const error = handleError(e).message;
          if (error === TOKEN_EXPIRY) {
            this.loginService.updateRedirectionCheck(TOKEN_EXPIRY_REENTER_MESSAGE);
          }
          return throwError(() => error);
        })
      );
  }

  submitNZMemberActivation(model: { sdcCardNo?: string, employeeId?: string, token?: string; }): Observable<CardActivationModel> {
    return this.httpClient
      .post(`${this.apigee_url}${api_url.NZ_ACTIVATION}`, model)
      .pipe(
        catchError((e) => {
          const error = handleError(e).message;
          if (error === TOKEN_EXPIRY) {
            this.loginService.updateRedirectionCheck(TOKEN_EXPIRY_REENTER_MESSAGE);
          }
          return throwError(() => error);
        })
      );
  }
}
